import { Injectable } from "@angular/core";
import { TabelaHorario } from "@tivic-team/manager-ts/dist/mob/entities/horario/tabela-horario.entity";
import { PagedResponse } from "app/interfaces/paged-response.inteface";
import { HorarioTableDTO } from "app/model/dtos/mob/horario-table.dto";
import { TabelaHorarioTableDTOList } from "app/model/dtos/mob/tabela-horario-table.dto";
import { TabelaHorarioDTO } from "app/model/dtos/mob/tabela-horario.dto";
import { HttpDelete, HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environmentv3 } from "src/environments/environmentv3";
import { ApiController } from "../api-controller.interface";
import { LinhaRotaTrechoHorarioDTO } from "app/model/dtos/mob/linha-rota-trecho-horario.dto";

@Injectable()
export class TabelaHorarioController implements ApiController<TabelaHorarioDTO>{

    constructor() { }
    
    find(filters?: IFilter): Promise<TabelaHorarioDTO[]> {
        throw new Error("Method not implemented.");
    }

    create(entity: TabelaHorarioDTO): Promise<TabelaHorarioDTO> {
        let request = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/tabelahorario',
                    environment: environmentv3
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new TabelaHorarioDTO()
            )
        );

        return request.call();
    }

    update(entity: TabelaHorarioDTO): Promise<TabelaHorarioDTO> {
        let request = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/tabelahorario/:cdTabelaHorario/:cdLinha',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdTabelaHorario: entity.cdTabelaHorario,
                        cdLinha: entity.cdLinha
                    })
                }),
                data: new JSONData(entity)
            }),
            new HttpResponse(
                new TabelaHorarioDTO()
            )
        );
        return request.call();
    }

    findTabelas(filters?: IFilter): Promise<PagedResponse<TabelaHorario>> {
        const request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/tabelahorario',
                    environment: environmentv3,
                    filter: filters
                })
            }),
            new HttpResponse(
                new Array<TabelaHorario>()
            )
        );
        return request.call();
    }

    pagedFindLinhaColetivoUrbano(filters?: IFilter): Promise<TabelaHorarioTableDTOList> {
        const request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/tabelahorario/coletivo-urbano',
                    environment: environmentv3,
                    filter: filters
                })
            }),
            new HttpResponse(new TabelaHorarioTableDTOList)
        );
        return request.call();
    }

    getHorarios(filters?: IFilter): Promise<HorarioTableDTO[]> {
        const request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/tabelahorario/horarios',
                    environment: environmentv3,
                    filter: filters
                })
            }),
            new HttpResponse(new Array<HorarioTableDTO>())
        );
        return request.call();
    }


    pagedFindLinhaColetivoRural(filters?: IFilter): Promise<TabelaHorarioTableDTOList> {
        const request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/tabelahorario/coletivo-rural',
                    environment: environmentv3,
                    filter: filters
                })
            }),
            new HttpResponse(new TabelaHorarioTableDTOList)
        );
        return request.call();
    }

    get(cdTabelaHorario: number, cdLinha: number): Promise<TabelaHorarioDTO> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/tabelahorario/:cdTabelaHorario/:cdLinha',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdTabelaHorario: cdTabelaHorario,
                        cdLinha: cdLinha
                    }),
                }),
            }),
            new HttpResponse(new TabelaHorarioDTO())
        );
        return request.call();
    }

    findTabelaHorario(id: number): Promise<TabelaHorario[]> {
        let request = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/tabelahorario/:cdLinha',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdLinha: id
                    }),
                }),
            }),
            new HttpResponse(new Array<TabelaHorario>())
        );
        return request.call();
    }

    async remove(cdTabelaHorario: number, cdLinha: number): Promise<TabelaHorario> {
        let request = new Quark(
            new HttpDelete({
                url: new Url({
                    id: 'mob/tabelahorario/:cdTabelaHorario/:cdLinha',
                    environment: environmentv3,
                    pathParams: new JSONData({
                        cdTabelaHorario: cdTabelaHorario,
                        cdLinha: cdLinha,
                    })
                }),
            }),
            new HttpResponse(
                new TabelaHorarioDTO()
            )
        );
        return request.call();
    }

    
	async getHorariosTabela(cdTabelaHorario: number, cdLinha: number):Promise<LinhaRotaTrechoHorarioDTO>{
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/tabelahorario/:cdTabelaHorario/:cdLinha/horarios',
					environment: environmentv3,
					pathParams: new JSONData({ cdTabelaHorario: cdTabelaHorario, cdLinha: cdLinha })
				})
			}),
			new HttpResponse(
				{} as LinhaRotaTrechoHorarioDTO
			)
        );
        return await quark.call();
	}
}